import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import Modalposting from "../Postings/PostingModal.jsx";
import MattersCombobox from "../Postings/MattersComboBox.jsx";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Checkbox, RadioGroup, TextArea } from "@progress/kendo-react-inputs";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { useChitPostingGridData } from "./useChitPostingGridData.js";
import { applyChitPostingRowTransforms } from "./chitPostingTransformList.js";
import { CHIT_STATUS_TABS, PostingStatus } from "./chitPostingConstants.js";
import {
  AmountFormatCell,
  DateFormatCell,
  formatDateForAPI,
  AmountFormat,
} from "components/common/formatter.js";
import { Button } from "@progress/kendo-react-buttons";
import BatchPostings from "pages/BatchPosting/index.jsx";
import { Dialog } from "@progress/kendo-react-dialogs";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton.jsx";

import * as api from "../../api/index.js";
import {
  AuthorizeChits,
  getChitRequest,
  rejectChitRequest,
} from "../../api/accountsAPI.js";
import DocumentViewer from "components/common/DocumentViewer";
import {
  downloadDocument,
  downloadDocumentAsPDF,
  getDocumentEditor,
  saveDocumentEditor,
} from "../../api/index.js";
import ChitImports from "pages/ChitRequest/ImportChits.jsx";
import ChitRequest from "pages/ChitRequest/ChitRequest.jsx";
import { toast } from "react-toastify";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { useActiveVats } from "services/vatService";
import { useActiveBranches } from "services/branchService.js";
import { GRID_PAGE_SIZES } from "components/common/GridComponents";
import { useCurrentUser } from "services/currentUserService.js";
import { useActiveFeeEarner } from "services/userService.js";
import { getPostingTypes } from "services/postingTypesService.js";
import { useActiveSuppliers } from "services/supplierService.js";
import { useCompany } from "services/companyService.js";
import { arrowRotateCwIcon, caretAltDownIcon } from "@progress/kendo-svg-icons";
import { SvgIcon } from "@progress/kendo-react-common";
import DocumentIconCounter from "components/common/DocumentIconCounter.jsx";
import SubmitButton from "components/common/SubmitButton";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import PageTabItemTitle from "components/tabs/TabItem/PageTabItemTitle";
import { changeLedgerLink } from "actions/ledgerLinks.action";
import { useNavigate } from "react-router-dom";
import { GridLoader } from "components/GridLoader.jsx";
export { CHIT_STATUS_TABS } from "./chitPostingConstants.js";

const ChitPosting = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    isModal = false,
    onClose,
    onAddToBatch,
    component,
    defaultPostingType = null,
    defaultMatter = null,
    authorizationOnly = false,
    postingGroup = "chits",
    excludedChitIds = [],
  } = props;
  const useStatusTabs = !isModal && props.component !== "batchPosting";
  const [activeTabIndex, setActiveTabIndex] = useState(() =>
    props.authorizationOnly ? 1 : 0,
  );
  const date = new Date();
  const [modalvalue, setmodalvalue] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [showBatchPosting, setShowBatchPosting] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date()?.toISOString().split("T")[0]);
  const [fileData, setFileData] = useState([]);
  const [showDoc, setShowDoc] = useState(false);
  const [currentChitId, setCurrentChitId] = useState(null);
  const [currentChitMatterId, setCurrentChitMatterId] = useState(null);
  const [chitRequestModal, setChitRequestModal] = useState(false);
  const [selectedChit, setSelectedChit] = useState(null);
  const [documentLoader, setDocumentLoader] = useState(false);
  const { data: user } = useCurrentUser();
  const { data: branchesList } = useActiveBranches();
  const { data: feeearnerdata } = useActiveFeeEarner();
  const [matterref, setmatterref] = useState(
    defaultMatter
      ? typeof defaultMatter === "object"
        ? defaultMatter
        : defaultMatter
      : null,
  );
  const [list, setLists] = useState({
    data: [],
    total: 20,
  });
  const [authSelectAll, setAuthSelectAll] = useState(false);
  const [valueFrom, setValueFrom] = useState(false);
  const [valueTo, setValueTo] = useState(false);
  const [dataState, setDataState] = useState({
    take: 200,
    skip: 0,
    sort: [
      {
        field: "matterRef",
        dir: "asc",
      },
    ],
  });
  const [valuePosting, setValuePosting] = useState(
    defaultPostingType && postingGroup === "chits" ? [defaultPostingType] : [],
  );
  const [fromDateSelector, setFromDateSelector] = useState(date);
  const [postingStatus, setPostingStatus] = useState(
    props.authorizationOnly ? "" : "false",
  );
  const [showImports, setShowImports] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [authorized, setAuthorized] = useState([]);
  const [isAuthorizing, setIsAuthorizing] = useState(false);
  const [showRejectReasonDialog, setShowRejectReasonDialog] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [isRejecting, setIsRejecting] = useState(false);
  const [rejectChitId, setRejectChitId] = useState(null);

  const isRequestInProgress = useRef(false);
  const [isProcessingData, setIsProcessingData] = useState(false);

  const [postingTypes, setPostingTypes] = useState([]);
  const { data: suppliersdata } = useActiveSuppliers();
  const { data: activeVats } = useActiveVats();
  const isLoadingChitData = useSelector((state) => state.chitPosting.isLoading);

  const clearChitPostingSelection = useCallback(() => {
    setCheckedList([]);
    setSelectAll(false);
    setSelectedList([]);
    setAuthorized([]);
    setAuthSelectAll(false);
  }, []);

  const fetchData = async () => {
    try {
      // Use the posting group passed from parent, fallback to "chits"
      const groupToUse = postingGroup || "chits";
      const postingData = await getPostingTypes(groupToUse);
      if (!Array.isArray(postingData) || postingData.length === 0) return;
      setPostingTypes(postingData);
    } catch (error) {
      console.error("Failed to fetch posting types:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [postingGroup, props.name]);

  useEffect(() => {
    if (!useStatusTabs) return;
    clearChitPostingSelection();
  }, [activeTabIndex, useStatusTabs, clearChitPostingSelection]);

  // Apply default posting type when postingTypes are loaded (only if not already set)
  useEffect(() => {
    if (
      isModal &&
      defaultPostingType &&
      postingTypes.length > 0 &&
      valuePosting.length === 0
    ) {
      const matchingType = postingTypes.find(
        (type) => type.code === defaultPostingType.code,
      );
      if (matchingType) {
        setValuePosting([matchingType]);
      }
    }
  }, [isModal, defaultPostingType, postingTypes, valuePosting.length]);

  const [toDateSelector, setToDateSelector] = useState(date);
  const { data: company } = useCompany();
  const onChangeFromDateSelect = (event) => {
    setFromDateSelector(event.value);
    let fromDate = null;
    let date = new Date(event.value);
    if (event.value) {
      fromDate = formatDateForAPI(date);
    }
    setFromDate(fromDate);
    setValueFrom(true);
  };
  const onChangeToDateSelect = (event) => {
    setToDateSelector(event.value);
    let toDate = null;
    let date = new Date(event.value);
    if (event.value) {
      toDate = formatDateForAPI(date);
    }
    setToDate(toDate);
    setValueTo(true);
  };

  useEffect(() => {
    if (company.yearStartDate !== undefined) {
      let yearsToStartDate = new Date(company.yearStartDate);
      setFromDateSelector(yearsToStartDate);
      setFromDate(formatDateForAPI(yearsToStartDate));
    }
  }, [company.yearStartDate]);

  const onChangePosting = (event) => {
    setValuePosting([...event.value]);
  };

  const createState = (skip, take) => {
    let pagerSettings = {
      pageSizes: GRID_PAGE_SIZES,
    };
    return {
      pageSize: take,
      pageable: pagerSettings,
    };
  };
  const [state, setState] = useState(createState(0, 10));

  const changePostingStatus = (e) => {
    setPostingStatus(e.value);
  };
  const onChangematter = (event) => {
    if (event.target.value !== null && event.target.value !== undefined) {
      setmatterref(event?.target?.value);
    } else {
      setmatterref(null);
    }
    clearChitPostingSelection();
    if (!isRequestInProgress.current) {
      setTimeout(() => {
        setRefresh((prev) => !prev);
      }, 300);
    }
  };
  const dataStateChange = (e) => {
    if (
      e.dataState.sort !== undefined &&
      e.dataState.skip !== 0 &&
      dataState.sort !== e.dataState.sort
    ) {
      setDataState({ ...e.dataState, skip: 0 });
    } else if (e.dataState.sort[0] === undefined) {
      setDataState({
        ...e.dataState,
        sort: [
          {
            field: dataState.sort[0].field,
            dir: "asc",
          },
        ],
      });
    } else {
      setDataState(e.dataState);
    }
  };

  const handleChitTypeClick = (chitData) => {
    if (chitData.chitId) {
      // Create activity data structure similar to CaseActivitiesPage
      const activityData = {
        chitRequestId: chitData.chitId,
        details: chitData.details,
        date: chitData.date,
        feeEarnerRef: chitData.feeEarnerRef,
        ...chitData,
        // systemType: 'Accounts',
        // subType: 'ChitRequest'
      };
      setSelectedChit(activityData);
      setChitRequestModal(true);
    }
  };

  const handleMatterLedgerOpen = useCallback(
    (dataItem) => {
      const matterId = dataItem?.matterID;
      const matterRef = dataItem?.matterRef;
      if (!matterId || !matterRef) return;
      dispatch(changeLedgerLink("MatterLedger", { matterId, matterRef }));
      navigate("/accounts/matterledger");
    },
    [dispatch, navigate],
  );

  const MatterRefCell = (props) => {
    const matterId = props?.dataItem?.matterID;
    const matterRef = props?.dataItem?.matterRef;
    if (!matterId || !matterRef) return <td>{matterRef ?? ""}</td>;
    return (
      <td className="wrap-text">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => handleMatterLedgerOpen(props.dataItem)}
        >
          <u>{matterRef}</u>
        </span>
      </td>
    );
  };

  const TypeCell = (props) => {
    const { postingType } = props.dataItem;
    return (
      <td className="wrap-text">
        {props.dataItem.chitId ? (
          <u
            style={{ cursor: "pointer" }}
            onClick={() => handleChitTypeClick(props.dataItem)}
          >
            {postingType?.code}
          </u>
        ) : (
          postingType?.code
        )}
      </td>
    );
  };

  const openChitRequestEditor = (chitData) => {
    if (!chitData?.chitId) return;
    const activityData = {
      chitRequestId: chitData.chitId,
      details: chitData.details,
      date: chitData.date,
      feeEarnerRef: chitData.feeEarnerRef,
      ...chitData,
    };
    setSelectedChit(activityData);
    setChitRequestModal(true);
  };

  const ChitEditActionCell = ({ dataItem, label }) => (
    <td className="text-center">
      <Button
        className="common-btn"
        style={{ minWidth: "102px", height: "30px", padding: "0 12px" }}
        onClick={() => openChitRequestEditor(dataItem)}
      >
        {label}
      </Button>
    </td>
  );

  const PostHeaderCell = () => {
    return (
      <th className="text-center">
        <div className="d-flex align-items-center justify-content-center pt-1">
          <Checkbox checked={selectAll} onChange={handleSelectAll} />
        </div>
      </th>
    );
  };

  const resolveCheckboxChangeValue = (event, currentValue) => {
    if (typeof event?.value === "boolean") return event.value;
    if (typeof event?.target?.value === "boolean") return event.target.value;
    if (typeof event?.target?.checked === "boolean")
      return event.target.checked;
    return !currentValue;
  };

  const handleSelectAll = (event) => {
    const newSelectAll = resolveCheckboxChangeValue(event, selectAll);
    setSelectAll(newSelectAll);
    setLists((prevList) => {
      const updatedData = prevList.data.map((item) => {
        item.select = newSelectAll;
        return item;
      });

      setCheckedList(
        newSelectAll ? updatedData.map((item) => item.chitId) : [],
      );

      return { ...prevList, data: updatedData };
    });
  };

  const PostCell = (props) => {
    return (
      <td className="text-center">
        {props.dataItem.posted === false &&
          !props.dataItem.authorizationRequired ? (
          <Checkbox
            type="checkbox"
            checked={props.dataItem.select === true}
            onChange={() => {
              setLists((prevList) => {
                const updatedData = prevList.data.map((item) => {
                  if (item.chitId === props.dataItem.chitId) {
                    item.select = !item.select;

                    if (item.select) {
                      setCheckedList((prevList) => [...prevList, item.chitId]);
                    } else {
                      setCheckedList((prevList) =>
                        prevList.filter((id) => id !== item.chitId),
                      );
                    }
                  }
                  return item;
                });
                setSelectAll(updatedData.every((item) => item.select));
                return { ...prevList, data: updatedData };
              });
            }}
          />
        ) : null}
      </td>
    );
  };

  const filterParameters = useMemo(() => {
    const parameters = {};

    if (matterref !== null) {
      parameters.matterId = matterref?.matterId;
    }

    if (valuePosting.length !== 0) {
      parameters.postingTypes = valuePosting.map((p) => p.code);
    }

    if (valueFrom) {
      parameters.fromDate = fromDate;
    }

    if (valueTo) {
      parameters.toDate = toDate;
    }

    if (useStatusTabs) {
      parameters.chitStatus = CHIT_STATUS_TABS[activeTabIndex].status;
    } else if (isModal && component === "batchPosting") {
      parameters.chitStatus = "PendingPosting";
    } else {
      parameters.postingStatus = postingStatus;
      if (authorizationOnly) {
        parameters.authorizationRequired = true;
      }
    }

    return parameters;
  }, [
    matterref,
    valuePosting,
    valueFrom,
    fromDate,
    valueTo,
    toDate,
    useStatusTabs,
    activeTabIndex,
    isModal,
    component,
    postingStatus,
    authorizationOnly,
  ]);

  const dataReceived = useCallback(
    (incoming) => {
      if (incoming?.data) {
        if (excludedChitIds.length > 0) {
          const excludedSet = new Set(excludedChitIds);
          incoming.data = incoming.data.filter(
            (item) => !excludedSet.has(item.chitId),
          );
          incoming.total = incoming.data.length;
        }
        applyChitPostingRowTransforms(
          incoming,
          postingTypes,
          feeearnerdata,
          checkedList,
        );
        setLists(incoming);
      }
      isRequestInProgress.current = false;
      setIsProcessingData(false);
    },
    [postingTypes, feeearnerdata, checkedList, excludedChitIds],
  );

  useEffect(() => {
    const selectedInGrid = (list?.data || [])
      .filter((item) => item.select)
      .map((item) => item.chitId);

    setCheckedList((prev) => {
      if (
        prev.length === selectedInGrid.length &&
        prev.every((id, idx) => id === selectedInGrid[idx])
      ) {
        return prev;
      }
      return selectedInGrid;
    });

    const nextSelectAll =
      (list?.data || []).length > 0 &&
      (list?.data || []).every((item) => item.select === true);
    setSelectAll(nextSelectAll);
  }, [list?.data]);

  const selectedGridCount = useMemo(
    () => (list?.data || []).filter((item) => item.select === true).length,
    [list?.data],
  );

  useEffect(() => {
    setIsProcessingData(true);
  }, [filterParameters, dataState.skip, dataState.take, dataState.sort, refresh]);

  useChitPostingGridData({
    filterParameters,
    dataState,
    refresh,
    currentComponent:
      props.component === "batchPosting" ? "batchPosting" : "chitPosting",
    onDataReceived: dataReceived,
  });

  const addToBatch = () => {
    const data = list.data.filter((item) => item.select === true);

    const transformedData = data.map((item) => {
      const supplierName = suppliersdata?.find(
        (s) => s.supplierRef === item.supplierRef,
      )?.supplierName;
      const branchName = branchesList?.find(
        (b) => b.branchId === item.branchId,
      )?.branchName;
      const vatName = activeVats?.find(
        (v) => v.vatCodeId === item.vatCode,
      )?.display;
      return {
        ...item,
        postingCode: item.postingType,
        date: new Date(item.date),
        matterID:
          typeof item.matterID !== "object"
            ? {
              matterRef: item.matterRef,
              matterId: item.matterID,
            }
            : item.matterID,
        supplierRef:
          item.supplierRef && typeof item.supplierRef !== "object"
            ? {
              supplierRef: item.supplierRef,
              display: supplierName
                ? `${item.supplierRef} - ${supplierName}`
                : item.supplierRef,
            }
            : item.supplierRef,
        nominalRef:
          item.nominalRef && typeof item.nominalRef !== "object"
            ? {
              nominalRef: item.nominalRef,
              display: `${item.nominalInfo?.nominalRef} - ${item.nominalInfo?.nominalName}`,
            }
            : item.nominalRef,
        ddaBank:
          item.ddaBank && typeof item.ddaBank === "object"
            ? {
              ...item.ddaBank,
              display: `${item.ddaBank?.nominalRef} - ${item.ddaBank?.nominalName}`,
            }
            : item.ddaBank,
        officeBank:
          item.officeBank && typeof item.officeBank === "object"
            ? {
              ...item.officeBank,
              display: `${item.officeBank?.nominalRef} - ${item.officeBank?.nominalName}`,
            }
            : item.officeBank,
        clientBank:
          item.clientBank && typeof item.clientBank === "object"
            ? {
              ...item.clientBank,
              display: `${item.clientBank?.nominalRef} - ${item.clientBank?.nominalName}`,
            }
            : item.clientBank,
        feeEarnerRef:
          item.feeEarnerRef && typeof item.feeEarnerRef === "object"
            ? {
              ...item.feeEarnerRef,
              display: `${item.feeEarnerRef?.userRef} - ${item.feeEarnerRef?.displayname}`,
            }
            : item.feeEarnerRef,

        branchId:
          item.branchId && typeof item.branchId !== "object"
            ? {
              branchId: item.branchId,
              display: branchName
                ? `${item.branchId} - ${branchName}`
                : item.branchId,
            }
            : item.branchId,

        vatCode:
          item.vatCode && typeof item.vatCode !== "object"
            ? {
              vatCodeId: item.vatCode,
              display: vatName,
            }
            : item.vatCode,
      };
    });

    setSelectedList(transformedData);
    if (component === "batchPosting" || isModal) {
      onAddToBatch(transformedData);
      onClose();
    } else {
      setShowBatchPosting(true);
    }
  };

  const authorizeChit = async () => {
    const data = authorized.map((chitId) => ({ chitID: chitId }));
    setIsAuthorizing(true);
    try {
      const response = await AuthorizeChits(data);
      if (response.status === 200) {
        handleRefresh();
        toast.success("Chit authorised successfully");
      }
    } catch (error) {
    } finally {
      setIsAuthorizing(false);
    }
  };

  const handleRejectChit = async () => {
    if (!rejectChitId) return;
    if (!rejectReason?.trim()) {
      toast.error("A rejection reason is required.");
      return;
    }
    setIsRejecting(true);
    try {
      await rejectChitRequest(rejectChitId, {
        rejectReason: rejectReason.trim(),
      });
      toast.success("Chit rejected.");
      setShowRejectReasonDialog(false);
      setRejectReason("");
      setRejectChitId(null);
      handleRefresh();
    } catch (error) {
      toast.error("Could not reject chit.");
    } finally {
      setIsRejecting(false);
    }
  };

  const handleRefresh = () => {
    isRequestInProgress.current = false;
    clearChitPostingSelection();
    setRefresh(!refresh);
  };

  const updateSingleChitRow = async (chitId) => {
    try {
      // Fetch the updated chit data
      const response = await getChitRequest(chitId);
      let updatedChit = response.data?.data;

      if (!updatedChit) return;

      // Transform postingType from string to object if needed
      // API returns it as a string like "CCR", but grid expects { code: "CCR" }
      if (
        updatedChit.postingType &&
        typeof updatedChit.postingType === "string"
      ) {
        const postingTypeCode = updatedChit.postingType;
        const postingTypeObj = postingTypes.find(
          (pt) => pt.code === postingTypeCode,
        );
        updatedChit = {
          ...updatedChit,
          postingType: postingTypeObj || { code: postingTypeCode },
        };
      }

      // Transform feeEarnerRef from string to object (same as dataReceived function line 539-544)
      if (
        updatedChit.feeEarnerRef &&
        typeof updatedChit.feeEarnerRef === "string"
      ) {
        updatedChit.feeEarnerRefOriginal = updatedChit.feeEarnerRef;
        const feeEarner = feeearnerdata?.find(
          (fe) => fe.userRef === updatedChit.feeEarnerRef,
        );
        if (feeEarner) {
          updatedChit.feeearner = feeEarner;
          updatedChit.feeEarnerRef = feeEarner;
        }
      }

      // Handle nominal/bank transformations for specific posting types (same as dataReceived line 519-537)
      if (updatedChit.postingType?.code) {
        const code = updatedChit.postingType.code;

        // Transform ddaBank for DCR, DDR posting types
        if (code === "DCR" || code === "DDR") {
          updatedChit.ddaBank = updatedChit.nominalInfo;
        }

        // Transform clientBank for CCR, CDR posting types
        if (code === "CCR" || code === "CDR") {
          updatedChit.clientBank = updatedChit.nominalInfo;
        }

        // Transform officeBank for OCR, ODR, DPU posting types
        if (code === "OCR" || code === "ODR" || code === "DPU") {
          updatedChit.officeBank = updatedChit.nominalInfo;
        }
      }

      // Check if the updated chit matches current filters
      const matchesFilter = () => {
        // Check posting status filter
        if (
          filterParameters.postingStatus === "true" &&
          !updatedChit.isPosted
        ) {
          return false;
        }
        if (
          filterParameters.postingStatus === "false" &&
          updatedChit.isPosted
        ) {
          return false;
        }

        // Check posting type filter
        if (
          filterParameters.postingTypes &&
          filterParameters.postingTypes.length > 0
        ) {
          const postingCode =
            updatedChit.postingType?.code || updatedChit.postingType;
          if (!filterParameters.postingTypes.includes(postingCode)) {
            return false;
          }
        }

        // Check matter filter
        if (
          filterParameters.matterId &&
          updatedChit.matterID !== filterParameters.matterId
        ) {
          return false;
        }

        // Check if rejected
        if (updatedChit.isRejected) {
          return false;
        }

        return true;
      };

      setLists((prevList) => {
        const newData = [...prevList.data];
        const rowIndex = newData.findIndex((item) => item.chitId === chitId);

        if (rowIndex !== -1) {
          if (matchesFilter()) {
            // Preserve the select state from the existing row (same as dataReceived line 545-549)
            updatedChit.select = checkedList.includes(chitId);
            // Update the row with new data
            newData[rowIndex] = updatedChit;
          } else {
            // Remove the row if it no longer matches filters
            newData.splice(rowIndex, 1);
          }
        } else if (matchesFilter()) {
          // If row not found but matches filter, add it (shouldn't normally happen)
          updatedChit.select = false;
          newData.unshift(updatedChit);
        }

        return {
          ...prevList,
          data: newData,
          total: newData.length,
        };
      });

      // Update checked list if the chit was checked
      setCheckedList((prevChecked) => {
        if (prevChecked.includes(chitId)) {
          if (!matchesFilter()) {
            // Remove from checked list if no longer matches filter
            return prevChecked.filter((id) => id !== chitId);
          }
        }
        return prevChecked;
      });
    } catch (error) {
      console.error("Error updating chit row:", error);
      // Fallback to full refresh if update fails
      handleRefresh();
    }
  };

  const postingDoc = async (chitId) => {
    // setShow(!show);
    try {
      const { data } = await api.getChitDocuments(chitId);
      setFileData(data.data);
      setCurrentChitId(chitId);
      // Find the chit in the list to get its matterId
      const chit = list?.data?.find((item) => item.chitId === chitId);
      const matterId = chit?.matterID || chit?.matterId || matterref?.matterId;
      setCurrentChitMatterId(matterId);
      setShowDoc(true);
    } catch (error) { }
  };

  const handleDownload = async (documentId, asPDF = false) => {
    setDocumentLoader(true);
    try {
      if (!documentId) {
        toast.error("No document selected");
        setDocumentLoader(false);
        return;
      }

      const response = asPDF
        ? await downloadDocumentAsPDF(documentId)
        : await downloadDocument(documentId);

      const contentDisposition = response.headers["content-disposition"];
      let fileName;

      if (response.data?.filename) {
        fileName = response.data.filename;
      } else if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
        );
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, "");
        }
      }
      if (!fileName) {
        fileName =
          (response.data?.fileID || "downloaded-document") +
          (asPDF ? ".pdf" : "");
      }

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const tempLink = document.createElement("a");
      tempLink.href = url;
      tempLink.setAttribute("download", fileName);
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
    } finally {
      setDocumentLoader(false);
    }
  };

  const handleRefreshDocument = async (documentId) => {
    if (!currentChitId) return;
    setDocumentLoader(true);
    try {
      const { data } = await api.getChitDocuments(currentChitId);
      setFileData(data.data);
      // Preserve matterId when refreshing - find the chit again if matterId is not set
      if (!currentChitMatterId) {
        const chit = list?.data?.find((item) => item.chitId === currentChitId);
        const matterId =
          chit?.matterID || chit?.matterId || matterref?.matterId;
        setCurrentChitMatterId(matterId);
      }
    } catch (error) {
    } finally {
      setDocumentLoader(false);
    }
  };

  const getDocumentEditorData = async (id, type) => {
    try {
      setDocumentLoader(true);
      const matterId = currentChitMatterId || matterref?.matterId;
      if (!matterId) {
        toast.error("Matter ID is required to edit the document.");
        setDocumentLoader(false);
        return;
      }
      const { data } = await getDocumentEditor(id, matterId);
      let editUrl = data?.data?.editURL;
      if (type === "Local") {
        let ext = "";
        const doc = fileData?.find((f) => f.documentId === id);
        if (doc && doc.documentName) {
          ext = doc.documentName.split(".").pop().toLowerCase();
        }
        if (["xls", "xlsx"].includes(ext)) {
          editUrl = `ms-excel:ofe|u|${editUrl}`;
        } else {
          editUrl = `ms-word:ofe|u|${editUrl}`;
        }
      }
      window.open(editUrl, "_blank");
      handleRefreshDocument(id);
    } catch (error) {
      const statusCode = error?.response?.status;
      if (statusCode !== 460) {
      }
    } finally {
      setDocumentLoader(false);
    }
  };

  const saveDocuemntEdit = async (id) => {
    try {
      const matterId = currentChitMatterId || matterref?.matterId;
      if (!matterId) {
        toast.error("Matter ID is required to save the document.");
        return;
      }
      await saveDocumentEditor(id, matterId);
      toast.success("Document Saved");
      handleRefreshDocument(id);
    } catch (error) {
    } finally {
      setDocumentLoader(false);
    }
  };

  const DocumentCounterCell = (e) => {
    return (
      <td className="px-0">
        <DocumentIconCounter
          count={e.dataItem.documentCount}
          onClick={() => postingDoc(e.dataItem.chitId)}
        />
      </td>
    );
  };

  const SupplierPayeeBankCell = (e) => {
    const b = e.dataItem;
    const t = (v) => v?.trim();

    const supplier = t(b.supplierRef);
    const payee = t(b.payer);
    const sortCode = t(b.bankSortCode);
    const accNo = t(b.bankAccountNo);
    const bankName = t(b.bankAccountName);

    return (
      <td>
        <div
          className="d-flex flex-column align-items-start"
          style={{ fontSize: "0.85rem" }}
        >
          {supplier && (
            <div>
              <strong>Supplier:</strong> {supplier}
            </div>
          )}
          {payee && (
            <div>
              <strong>Payee:</strong> {payee}
            </div>
          )}
          {bankName && (
            <div>
              <strong>Bank Name:</strong> {bankName}
            </div>
          )}
          {(sortCode || accNo) && (
            <div>
              {sortCode && accNo ? (
                <>
                  <strong>Acc:</strong> {accNo} | <strong>Sort:</strong>{" "}
                  {sortCode}
                </>
              ) : (
                sortCode || accNo
              )}
            </div>
          )}
        </div>
      </td>
    );
  };

  const DetailsCell = (e) => {
    const d = e.dataItem.details?.trim();
    const n = e.dataItem.notes?.trim();

    return (
      <td>
        {(d || n) && (
          <div className="d-flex flex-column align-items-start small">
            {d && <div className="fw-medium">{d}</div>}
            {n && (
              <div>
                <strong>Notes:</strong> {n}
              </div>
            )}
          </div>
        )}
      </td>
    );
  };

  const AuthorizationCell = (e) => {
    const isExcluded = e.dataItem.excludedAuthUsers?.includes(user?.userRef);
    const isDisabled =
      isExcluded ||
      (!user?.profile?.accounts?.AuthorizationLevel1 &&
        !user?.profile?.accounts?.AuthorizationLevel2 &&
        !user?.profile?.accounts?.AuthorizationLevel3);

    const tooltipMessage = isExcluded
      ? `User '${user?.userRef}' cannot authorise multiple levels of the same Chit Request`
      : "You do not have the required authorisation level to authorise this Chit Request";

    const handleAuthorizationChange = () => {
      if (isDisabled) return;
      setLists((prevList) => {
        const updatedData = prevList.data.map((item) => {
          if (item.chitId === e.dataItem.chitId) {
            item.auth = !item.auth;

            if (item.auth) {
              setAuthorized((prevList) => [...prevList, item.chitId]);
              setCheckedList((prevList) => [...prevList, item.chitId]);
            } else {
              setAuthorized((prevList) =>
                prevList.filter((id) => id !== item.chitId),
              );
              setCheckedList((prevList) =>
                prevList.filter((id) => id !== item.chitId),
              );
            }
          }
          return item;
        });
        return { ...prevList, data: updatedData };
      });
    };

    return (
      <td className="align-middle px-1">
        {e.dataItem?.authorizationRequired && (
          <div className="d-flex justify-content-center align-items-center">
            <Tooltip
              anchorElement="target"
              position="top"
              parentTitle
              style={{ maxWidth: "275px" }}
            >
              <span title={isDisabled ? tooltipMessage : undefined}>
                <Checkbox
                  checked={e.dataItem.auth}
                  disabled={isDisabled}
                  onChange={handleAuthorizationChange}
                />
              </span>
            </Tooltip>
          </div>
        )}
      </td>
    );
  };

  const handleAuthSelectAll = (event) => {
    const newValue = resolveCheckboxChangeValue(event, authSelectAll);
    setLists((prevList) => {
      const updatedData = prevList.data.map((item) => {
        const isDisabled =
          item.excludedAuthUsers?.includes(user?.userRef) ||
          (!user?.profile?.accounts?.AuthorizationLevel1 &&
            !user?.profile?.accounts?.AuthorizationLevel2 &&
            !user?.profile?.accounts?.AuthorizationLevel3);

        if (item.authorizationRequired) {
          item.auth = isDisabled ? false : newValue;
        }
        return item;
      });

      const newAuthorizedIds = updatedData
        .filter((item) => item.auth)
        .map((item) => item.chitId);

      setAuthorized(newAuthorizedIds);
      setCheckedList(newAuthorizedIds);
      setAuthSelectAll(newValue);

      return { ...prevList, data: updatedData };
    });
  };

  const AuthorizationHeaderCell = () => {
    return (
      <th className="text-center">
        <div className="d-flex align-items-center justify-content-center pt-1">
          <Checkbox checked={authSelectAll} onChange={handleAuthSelectAll} />
        </div>
      </th>
    );
  };

  const showAuthColumn =
    authorizationOnly || (useStatusTabs && activeTabIndex === 1);
  const showPostColumn =
    !authorizationOnly && (!useStatusTabs || activeTabIndex === 0);
  const showUpdateColumn = useStatusTabs && activeTabIndex === 3;
  const showAmendColumn = useStatusTabs && activeTabIndex === 2;
  const authorizationCells = showAuthColumn
    ? { data: AuthorizationCell, headerCell: AuthorizationHeaderCell }
    : { data: AuthorizationCell };

  const showRowRejectColumn =
    useStatusTabs && (activeTabIndex === 0 || activeTabIndex === 1);

  const GrossAmountCell = (props) => {
    const gross =
      (props.dataItem.netAmount || 0) + (props.dataItem.vatAmount || 0);
    return (
      <td className="text-end">
        <span>{AmountFormat(gross)}</span>
      </td>
    );
  };

  const RejectCell = ({ dataItem }) => (
    <td className="text-center">
      <Button
        className="common-btn"
        style={{ minWidth: "72px", height: "30px", padding: "0 10px" }}
        onClick={() => {
          setRejectChitId(dataItem.chitId);
          setRejectReason("");
          setShowRejectReasonDialog(true);
        }}
      >
        Reject
      </Button>
    </td>
  );

  const AmountNameHeader = (props) => {
    return (
      <div
        onClick={(e) => {
          props.onClick(e);
        }}
        style={{ textAlign: "center", cursor: "pointer" }}
      >
        {props.title}
        {props.children}
      </div>
    );
  };

  const IS_BATCH_POSTING = props.component === "batchPosting";

  const RefreshButton = ({ className }) => (
    <Button
      className={`common-btn mb-1 ${className ?? ""}`}
      onClick={handleRefresh}
      svgIcon={arrowRotateCwIcon}
    >
      <span className="d-flex align-items-center">
        <span className="d-block d-xl-none d-xxl-inline-block ms-1">
          Refresh
        </span>
      </span>
    </Button>
  );

  const FromToDate = ({ className = "" }) => (
    <div className={`mt-1 flex-shrink-0 ${className}`.trim()}>
      <div className="nominal-form-to-parent-row">
        <div className="labels-containers">
          <Label editorId={"dp"}>From</Label>
          <div className="label-to">
            <Label editorId="to">To</Label>
          </div>
        </div>
      </div>
      <div className="nominal-form-to-row">
        <div className="date-form-to-wrapper">
          <div className="from">
            <div className="d-flex align-items-center justify-content-center">
              <Checkbox
                value={valueFrom}
                className="ms-2 me-1"
                onChange={(e) => {
                  setValueFrom(e.value);
                }}
                label={""}
              />
              <DatePicker
                id="from"
                className="date-picker"
                value={fromDateSelector || null}
                onChange={onChangeFromDateSelect}
                toggleButton={CalenderCustomToggleButton}
              />
            </div>
          </div>
          <div className="divider"></div>
          <div className="to">
            <div className="d-flex align-items-center justify-content-center">
              <Checkbox
                value={valueTo}
                className="ms-2 me-1"
                onChange={(e) => {
                  setValueTo(e.value);
                }}
                label={""}
              />
              <DatePicker
                id="to"
                className="date-picker"
                value={toDateSelector || null}
                onChange={onChangeToDateSelect}
                toggleButton={CalenderCustomToggleButton}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderContent = () => (
    <div
      className={
        isModal
          ? "d-flex px-3 py-3 flex-column"
          : "page pt-2 px-0 h-100 d-flex flex-column"
      }
      style={isModal ? { height: "100%", minHeight: "0" } : {}}
    >
      {showDoc && (
        <DocumentViewer
          data={fileData}
          onClose={() => {
            setShowDoc(false);
            setCurrentChitId(null);
            setCurrentChitMatterId(null);
            setFileData([]);
          }}
          onDownload={handleDownload}
          onRefresh={handleRefreshDocument}
          loader={documentLoader}
          matterId={currentChitMatterId || matterref?.matterId}
          matter={matterref}
          component="chitPosting"
          onEditDoc={(e, type) => getDocumentEditorData(e, type)}
          saveDocuemntEdit={saveDocuemntEdit}
        />
      )}
      <div className="d-flex flex-wrap align-items-end gap-2 gap-md-3 w-100 mb-2">
        <div className="d-flex flex-wrap align-items-end gap-2 flex-grow-1 min-w-0">
          <div className="d-flex flex-column flex-shrink-0">
            <Label className="mb-1 filter-font">Posting Type</Label>
            <MultiSelect
              data={postingTypes}
              onChange={onChangePosting}
              textField="code"
              value={valuePosting}
              className="dropdown-width px-1"
              placeholder="Select Posting Type"
              suffix={() => (
                <span className=" d-flex justify-content-center align-items-center me-2 cursor-pointer">
                  <SvgIcon icon={caretAltDownIcon} />
                </span>
              )}
            />
          </div>
          <div className="d-flex flex-column flex-shrink-0">
            <Label className="mb-1 filter-font">Matter</Label>
            <MattersCombobox
              onChangematter={onChangematter}
              className="dropdown-width"
              value={matterref}
            />
          </div>
          <div className="flex-shrink-0">
            <FromToDate />
          </div>
          <div className="flex-shrink-0">
            <RefreshButton />
          </div>
          {!IS_BATCH_POSTING && !authorizationOnly && !useStatusTabs && (
            <div className="d-flex flex-column radio flex-shrink-0">
              <Label className="filter-font pt-0 mb-1">Type</Label>
              <RadioGroup
                data={PostingStatus}
                onChange={changePostingStatus}
                defaultValue={PostingStatus[0].value}
                className="d-flex flex-row radio-group-gap"
              />
            </div>
          )}
        </div>
        {useStatusTabs &&
          activeTabIndex === 3 &&
          !IS_BATCH_POSTING &&
          !authorizationOnly &&
          !isModal && (
            <div className="d-flex mb-1 align-items-end flex-shrink-0">
              <Button
                className="common-btn d-flex align-items-center justify-content-center text-center"
                type="button"
                onClick={() => {
                  setSelectedChit({ unallocatedOnly: true });
                  setChitRequestModal(true);
                }}
              >
                <span
                  className="d-flex flex-column align-items-center"
                  style={{ lineHeight: "15px" }}
                >
                  <span>Add</span>
                  <span>Unallocated</span>
                </span>
              </Button>
            </div>
          )}
      </div>

      <div
        className={isModal ? "mt-3 flex-grow-1" : "mt-3"}
        style={{
          height: isModal ? "calc(100vh - 450px)" : "calc(100vh - 250px)",
          overflow: "hidden",
        }}
      >
        <Grid
          {...dataState}
          data={list}
          onDataStateChange={dataStateChange}
          className="grid-minwidth-col5-150"
          style={{ height: "100%", overflow: "hidden" }}
          sortable={true}
          pageable={state.pageable}
          pageSize={state.pageSize}
          //loading={isLoadingChitData || isProcessingData}
          showLoader={isLoadingChitData || isProcessingData}
          loader={
            <GridLoader />
          }
        >
          <GridNoRecords>
            {isLoadingChitData || isProcessingData ? (
              <span></span>
            ) : (
              list.data && list.data.length === 0 && "No records available"
            )}
          </GridNoRecords>
          <GridColumn
            field="postingType"
            title="Type"
            width="65px"
            cells={{ data: TypeCell }}
          />

          <GridColumn
            field="date"
            title="Date"
            cells={{ data: DateFormatCell }}
            width="100px"
            className="px-1"
          />

          <GridColumn
            field="matterRef"
            title="Matter"
            width="120px"
            cells={{ data: MatterRefCell }}
          />

          <GridColumn
            title="Ref"
            field="reference"
            width="80px"
            className="px-1"
          />

          <GridColumn
            field="details"
            title="Details"
            cells={{ data: DetailsCell }}
          />

          <GridColumn field="feeEarnerRefOriginal" title="FE" width="60px" />

          <GridColumn title=" " cells={{ data: SupplierPayeeBankCell }} />

          <GridColumn
            field="vatAmount"
            title="Vat"
            cells={{ data: AmountFormatCell }}
            width="90px"
            headerClassName="grid-header-center"
          />
          <GridColumn
            title="Amount"
            cells={{ data: GrossAmountCell }}
            width="120px"
            headerClassName="grid-header-center"
          />
          <GridColumn
            field="documentCount"
            title=" "
            width="20px"
            cells={{ data: DocumentCounterCell }}
            headerClassName="grid-header-center"
          />
          {showAuthColumn && (
            <GridColumn
              field="authorizationRequired"
              title="Select"
              width="80px"
              cells={authorizationCells}
            />
          )}

          {showPostColumn && (
            <GridColumn
              field=""
              title=""
              cells={{ data: PostCell, headerCell: PostHeaderCell }}
              width="60px"
              headerClassName="text-center align-middle p-0"
            />
          )}
          {showUpdateColumn && (
            <GridColumn
              field=""
              title=""
              width="130px"
              cells={{
                data: (props) => (
                  <ChitEditActionCell {...props} label="Update" />
                ),
              }}
              headerClassName="text-center align-middle p-0"
            />
          )}
          {showAmendColumn && (
            <GridColumn
              field=""
              title=""
              width="130px"
              cells={{
                data: (props) => (
                  <ChitEditActionCell {...props} label="Amend" />
                ),
              }}
              headerClassName="text-center align-middle p-0"
            />
          )}
          {showRowRejectColumn && (
            <GridColumn
              field=""
              title=""
              width="115px"
              cells={{ data: RejectCell }}
              headerClassName="text-center align-middle p-0"
            />
          )}
        </Grid>
      </div>

      {!isModal && (
        <div className="d-flex justify-content-between mt-3 flex-wrap gap-2">
          <div className="col-auto d-flex flex-wrap gap-2">
            {(!useStatusTabs || activeTabIndex === 0) && !authorizationOnly && (
              <Button
                className="common-btn"
                type="button"
                style={{ maxWidth: "130px" }}
                onClick={() => {
                  setShowImports(true);
                }}
              >
                Import Chits
              </Button>
            )}
          </div>
          <div className="col-auto d-flex gap-2 flex-wrap">
            {(!useStatusTabs || activeTabIndex === 1) && (
              <SubmitButton
                type="button"
                isLoading={isAuthorizing}
                disabled={authorized.length === 0}
                onClick={authorizeChit}
                className="common-btn"
                style={{ maxWidth: "130px" }}
              >
                Authorise Chit
              </SubmitButton>
            )}
            {(!useStatusTabs || activeTabIndex === 0) && !authorizationOnly && (
              <>
                <Button
                  className="common-btn"
                  style={{ maxWidth: "140px" }}
                  disabled={selectedGridCount === 0}
                  onClick={addToBatch}
                >
                  Add to Batch{" "}
                  {selectedGridCount > 0 && `(${selectedGridCount})`}
                </Button>
              </>
            )}
          </div>
        </div>
      )}
      {showImports && <ChitImports cancelEdit={() => setShowImports(false)} />}
      <Modalposting
        value={modalvalue}
        closeModal={() => {
          setmodalvalue(false);
        }}
        component={"Posting"}
      ></Modalposting>
      {showBatchPosting && (
        <Dialog
          style={{ overflow: "hidden" }}
          title={`Batch Posting`}
          className="batch-posting-dialog dialog-xxl"
          onClose={() => {
            setShowBatchPosting(false);
            clearChitPostingSelection();
          }}
        >
          <div className="h-100 w-100">
            <BatchPostings
              type={"chitPosting"}
              selectedList={selectedList}
              onClose={() => {
                setShowBatchPosting(false);
                handleRefresh();
              }}
            />
          </div>
        </Dialog>
      )}
      {chitRequestModal && (
        <ChitRequest
          cancelEdit={(dataWasModified = false, opts) => {
            setChitRequestModal(false);
            const chitId = selectedChit?.chitRequestId || selectedChit?.chitId;
            setSelectedChit(null);
            if (dataWasModified) {
              if (opts?.fullRefresh) {
                handleRefresh();
              } else if (chitId) {
                updateSingleChitRow(chitId);
              } else {
                handleRefresh();
              }
            }
          }}
          matter={
            selectedChit?.unallocatedOnly
              ? null
              : {
                matterId: selectedChit?.matterID,
                matterRef: selectedChit?.matterRef,
              }
          }
          component={"modal"}
          postingGroup={postingGroup}
          activityData={selectedChit}
        />
      )}
      {showRejectReasonDialog && (
        <Dialog
          title="Reject Chit"
          onClose={() => {
            setShowRejectReasonDialog(false);
            setRejectReason("");
            setRejectChitId(null);
          }}
          width={460}
        >
          <div className="p-3">
            <Label className="label mb-2 d-block">Rejection Reason</Label>
            <TextArea
              className="w-100"
              rows={5}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.value)}
              placeholder="Enter reason for rejection..."
              style={{ resize: "none" }}
            />
          </div>
          <div className="dialog-footer d-flex justify-content-end gap-2">
            <Button
              className="common-btn bgBtnSecondary"
              onClick={() => {
                setShowRejectReasonDialog(false);
                setRejectReason("");
                setRejectChitId(null);
              }}
              disabled={isRejecting}
            >
              Cancel
            </Button>
            <SubmitButton
              className="common-btn me-3"
              onClick={handleRejectChit}
              disabled={isRejecting || !rejectReason.trim()}
              isLoading={isRejecting}
            >
              Reject
            </SubmitButton>
          </div>
        </Dialog>
      )}
    </div>
  );

  return isModal ? (
    <Dialog
      title="Select Chit Request"
      onClose={onClose}
      className="dialog-xxxl"
    >
      <div className="d-flex flex-column h-100">
        <div className="flex-grow-1">{renderContent()}</div>

        <div className="dialog-footer">
          <Button
            className="common-btn bgBtnSecondary border-0 me-2"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="common-btn me-4"
            onClick={addToBatch}
            disabled={selectedGridCount === 0}
          >
            Add to Batch ({selectedGridCount})
          </Button>
        </div>
      </div>
    </Dialog>
  ) : useStatusTabs ? (
    <div className="page h-100 w-100 d-flex flex-column">
      <TabStrip
        className="pagetab mt-3 h-100 w-100 d-flex flex-column"
        selected={activeTabIndex}
        onSelect={(e) => setActiveTabIndex(e.selected)}
        keepTabsMounted={true}
        scrollable={true}
      >
        {CHIT_STATUS_TABS.map((tab, index) => (
          <TabStripTab
            key={tab.key}
            title={
              <PageTabItemTitle
                title={tab.label}
                index={index}
                selected={activeTabIndex}
              />
            }
            contentClassName="h-100 mt-2 flex-grow-1 min-h-0 d-flex flex-column"
          >
            {activeTabIndex === index ? renderContent() : null}
          </TabStripTab>
        ))}
      </TabStrip>
    </div>
  ) : (
    renderContent()
  );
};
export default ChitPosting;
